import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Logo from 'src/assets/logo.svg';
import { ThemeAwareLogo } from 'src/lib/components/ThemeAwareLogo';

export const ClientLogoWithText = () => {
    const { t } = useTranslation('lib.components.logoWithText');

    return (
        <Stack mb={4} display="flex" alignItems="center">
            <ThemeAwareLogo src={Logo} alt="ResQ" tintInDarkMode style={{ width: 110 }} />
            <Typography fontWeight={'700'} fontSize={'14px'}>
                {t('subtitleText')}
            </Typography>
        </Stack>
    );
};
